import styled, { css } from "styled-components";
import { propStyling, tombac } from "../../../shared";
const sizeStyles = tombac.variant("size", {
  m: css(["height:", ";"], tombac.space(5)),
  s: css(["height:", ";"], tombac.space(4)),
  xs: css(["height:", ";"], tombac.space(3.5))
});
export const GroupContainer = styled.div.withConfig({
  displayName: "GroupContainer"
})(["all:initial;", " ", " ", ""], _ref => {
  let {
    theme: {
      components: {
        toggleGroup: {
          current: {
            root
          } = {}
        }
      }
    }
  } = _ref;
  return css(["", " border:", " solid ", ";border-radius:999rem;box-sizing:border-box;display:flex;height:", ";margin:0;width:max-content;padding:", ";transition:border-color 0.1s ease-out;"], _ref2 => {
    let {
      disabled
    } = _ref2;
    return tombac.text({
      color: disabled ? tombac.alpha("neutral", 24) : undefined
    });
  }, tombac.unit(1), _ref3 => {
    let {
      disabled,
      isFocusVisible,
      isInvalid
    } = _ref3;
    return !disabled && isFocusVisible ? tombac.parse(root.focusVisible.borderColor) : isInvalid ? tombac.parse(root.invalid.borderColor) : tombac.parse(root.borderColor);
  }, tombac.space(5), tombac.unit(2, 1));
}, sizeStyles, propStyling);
//# sourceMappingURL=GroupContainer.js.map